import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import EventoPrivadoCard from "@/components/common/EventoPrivadoCard";
import { getEventosVisiblesParaSocio, hidratarEventosPublicos } from "@/data/adminEventosStore";
import { getCurrentSocio } from "@/data/socioAuthStore";
import { SCREENS } from "@/constants/testIds";

const getSaludo = () => {
  const h = new Date().getHours();
  if (h >= 5 && h < 12) return "Buenos días";
  if (h >= 12 && h < 19) return "Buenas tardes";
  return "Buenas noches";
};

/**
 * Home privada del socio.
 * Lista los eventos publicados desde el portal administrativo.
 */
export default function Inicio() {
  const navigate = useNavigate();
  const saludo = useMemo(() => getSaludo(), []);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    hidratarEventosPublicos().then(() => setTick((t) => t + 1));
  }, []);
  const eventos = useMemo(() => getEventosVisiblesParaSocio(), [tick]);
  const socio = getCurrentSocio();
  // Primer nombre del socio autenticado; fallback "Socio" si aún no cargó.
  const nombreSocio = (socio?.nombre || "Socio").trim().split(/\s+/)[0];

  return (
    <div data-testid={SCREENS.inicio} className="flex flex-col gap-10">
      <header className="animate-fade-up">
        <span className="overline text-accent">Hola de nuevo</span>
        <h1
          data-testid="saludo-socio"
          className="mt-3 font-heading text-3xl sm:text-4xl tracking-tight text-foreground"
        >
          {saludo}, {nombreSocio}
        </h1>
      </header>

      <section className="animate-fade-up delay-100 flex flex-col gap-5">
        <h2 className="font-heading text-2xl sm:text-3xl text-foreground">
          Próximos eventos
        </h2>

        {eventos.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            Aún no hay eventos disponibles.
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {eventos.map((ev) => (
              <EventoPrivadoCard
                key={ev.id}
                evento={ev}
                testId={`evento-privado-${ev.id}`}
                onVer={() => navigate(`/app/eventos/${ev.id}`)}
              />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
